<template>
  <div class="page flex-col">
    <!-- 顶部导航由全局 SiteHeader 渲染，这里只呈现主内容 -->
    <div class="promotion-container">
      <h1 class="promotion-title">成果推广</h1>
      <div class="promotion-grid">
        <div class="promotion-card">
          <img class="promotion-image" src="https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/tg1.png" alt="成果推广图1" />
        </div>
        <div class="promotion-card">
          <img class="promotion-image" src="https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/tg2.png" alt="成果推广图2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuChengguoTuiguang'
};
</script>

<style scoped>
/* 页面主容器：居中显示、限制最大宽度以适配常见屏幕 */
.promotion-container { max-width: 1080px; margin: 36px auto; padding: 0 16px; }
.promotion-title { font-size: 24px; font-weight: 700; color: #222; text-align: center; margin-bottom: 20px; }

/* 两图栅格：在大屏横排，小屏纵排 */
.promotion-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
@media (max-width: 768px) { .promotion-grid { grid-template-columns: 1fr; } }

/* 图片卡片：留白、阴影与圆角，突出视觉层次 */
.promotion-card { background: #fff; border-radius: 10px; padding: 12px; box-shadow: 0 6px 18px rgba(0,0,0,0.08); display: flex; align-items: center; justify-content: center; }

/* 图片自适应：保持比例、居中展示 */
.promotion-image { max-width: 100%; height: auto; border-radius: 6px; transition: transform 0.25s ease; }
.promotion-card:hover .promotion-image { transform: scale(1.02); }
</style>